import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        shareObj: JSON.parse(localStorage.getItem("shareObj") )||{}
    },
    getters: {
        shareObj: function (state) {
            return state.shareObj
        },
    },
    mutations: {
        shareObj(state, data){
            state.shareObj = data;
        },
    },
    actions: {
    },
    modules: {
    }
})
